import { supabase } from '@/lib/supabase/client';

export interface Process {
  id: string;
  clientId: string;
  title: string;
  description: string | null;
  status: 'pending' | 'in_progress' | 'completed' | 'cancelled';
  startDate: string;
  endDate: string | null;
  assignedTo: string | null;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
}

export async function getProcessesByClientId(clientId: string): Promise<Process[]> {
  try {
    const { data, error } = await supabase
      .from('processes')
      .select('*')
      .eq('client_id', clientId)
      .order('created_at', { ascending: false });

    if (error) throw error;

    return (data || []).map(row => ({
      id: row.id,
      clientId: row.client_id,
      title: row.title,
      description: row.description,
      status: row.status,
      startDate: row.start_date,
      endDate: row.end_date,
      assignedTo: row.assigned_to,
      notes: row.notes,
      createdAt: row.created_at,
      updatedAt: row.updated_at
    }));
  } catch (error) {
    console.error('Error fetching processes:', error);
    return [];
  }
}

export async function getAllProcesses(): Promise<Process[]> {
  try {
    const { data, error } = await supabase
      .from('processes')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) throw error;

    return (data || []).map(row => ({
      id: row.id,
      clientId: row.client_id,
      title: row.title,
      description: row.description,
      status: row.status,
      startDate: row.start_date,
      endDate: row.end_date,
      assignedTo: row.assigned_to,
      notes: row.notes,
      createdAt: row.created_at,
      updatedAt: row.updated_at
    }));
  } catch (error) {
    console.error('Error fetching processes:', error);
    return [];
  }
}

export async function updateProcessStatus(processId: string, status: string): Promise<boolean> {
  try {
    const { error } = await supabase
      .from('processes')
      .update({ status })
      .eq('id', processId);

    if (error) throw error;
    return true;
  } catch (error) {
    console.error('Error updating process status:', error);
    return false;
  }
}